import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  palette: {
    primary: { main: "#9678D3", dark: "#7B5FBF", contrastText: "#FFFFFF" },
    secondary: { main: "#041E42", contrastText: "#FFFFFF" },
    success: { main: "#71CC9B" },
    error: { main: "#ba1a1a" },
    background: { default: "#fcf8fd", paper: "#ffffff" },
    divider: "#E5E1E6",
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ".picker-dialog-bg": { zIndex: "2000 !important" },
        ".picker-dialog": { zIndex: "2001 !important" },
      },
    },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: { textTransform: "none" },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: { borderRight: "1px solid #E5E1E6" },
      },
    },
  },
});
